 import BASEURLGESTTOR from '../api/gesttor'
import { BASEURLGESTTORFORMDATA } from '../api/gesttor'
import { dadosInterCliente, certificadoInter, chaveInter} from '../../interfaces/inter'

export function statusIntegracao () {
    return BASEURLGESTTOR.get('/inter/status')
}

export function novoDadosInter (payload: dadosInterCliente) {
    return BASEURLGESTTOR.post('/inter/dados', payload)
}

export function novoCertificado (pauload: certificadoInter) {
    return BASEURLGESTTORFORMDATA.post('/inter/certificado', pauload)
}

export function novaChave (payload: chaveInter) {
    return BASEURLGESTTORFORMDATA.post('/inter/chave', payload)
}

export function gerarTokenInter () {
    return BASEURLGESTTOR.post('/inter/token')
}

export function habilitarWebHook () {
    return BASEURLGESTTOR.put('/inter/webhook')
}